import styled from 'styled-components';
import { BackgroundColor, OpacityColor } from 'styles/Global/colorSemantic';
import { Body4SemiBold, Body5Medium } from 'styles/Global/typography';
import { formattedTime } from 'utils/calculateTime';
import LnbPatientListFillIcon from 'assets/Icons/SideBarList/LnbPatientListIFillcon';
import { DiagnosisStatus } from 'utils/statusCode';
import { changeAssessmentApiResponse } from 'models/Tablet/AssessmentApiTypes';
import IcCalendar from 'assets/Icons/Calendar/IcCalendar';
import { IconColor } from 'styles/Global/colorSemantic';
import { Caption1Medium } from 'styles/Global/typography';
import { TextColor } from 'styles/Global/colorSemantic';
import { BorderColor } from 'styles/Global/colorSemantic';

export default function InspectorInfo({ diagnosisInfo, isAiVoucher }: { diagnosisInfo: changeAssessmentApiResponse; isAiVoucher?: boolean }) {
    return (
        <InfoContainer $isAiVoucher={isAiVoucher ?? false}>
            <div>
                <ProfileAndNameContainer>
                    <ProfileContainer>
                        <LnbPatientListFillIcon />
                    </ProfileContainer>
                    <Body4SemiBold>{diagnosisInfo.patientName}</Body4SemiBold>
                </ProfileAndNameContainer>
                <GradeContainer>
                    <Body5Medium>{diagnosisInfo.gradeName}</Body5Medium>
                </GradeContainer>
            </div>

            {diagnosisInfo.status === DiagnosisStatus.counselReserved && (
                <ReservationContainer>
                    <ReservationTitleContainer>
                        <IcCalendar color={IconColor.color_icon_neutral} />
                        <Caption1Medium $color={TextColor.color_text_light}>상담 일시</Caption1Medium>
                    </ReservationTitleContainer>
                    <div
                        style={{
                            width: '1px',
                            height: '12px',
                            backgroundColor: BorderColor.color_border_normal,
                            justifyContent: 'center',
                        }}
                    />
                    <Body5Medium>{formattedTime(diagnosisInfo.diagnosisDateTime)}</Body5Medium>
                </ReservationContainer>
            )}
        </InfoContainer>
    );
}

const InfoContainer = styled.div<{ $isAiVoucher: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 12px 16px 14px 12px;
    width: 100%;
    border-radius: 8px;
    gap: 12px;
    border: ${(props) => props.$isAiVoucher && `1px solid ${BorderColor.color_border_weak}`};
    background-color: ${(props) => (props.$isAiVoucher ? BackgroundColor.color_background_white : BackgroundColor.color_background_light)};
`;

const ProfileAndNameContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;

const ProfileContainer = styled.div`
    display: flex;
    padding: 3px;
`;

const GradeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-left: 28px;
`;

const ReservationContainer = styled.div`
    display: flex;
    background-color: ${OpacityColor.color_opacity_neutral_6};
    gap: 10px;
    padding: 8px;
    border-radius: 4px;
    align-items: center;
`;

const ReservationTitleContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    border-radius: 4px;
`;
